type ValidationDetail = {
  loc?: Array<string | number>;
  msg?: string;
  message?: string;
  type?: string;
};

function formatLocation(loc: ValidationDetail['loc']): string {
  if (!Array.isArray(loc) || loc.length === 0) return '';
  return loc
    .filter((part) => part !== 'body')
    .map(String)
    .join('.');
}

function formatValidationDetail(item: unknown): string | null {
  if (!item || typeof item !== 'object') return null;
  const detail = item as ValidationDetail;
  const message = detail.msg || detail.message;
  if (!message) return null;

  const location = formatLocation(detail.loc);
  return location ? `${location}: ${message}` : message;
}

export function extractHttpErrorMessage(responseData: unknown, fallback: string): string {
  if (!responseData || typeof responseData !== 'object') {
    return fallback;
  }

  const data = responseData as { detail?: unknown; message?: unknown; error?: unknown };
  const detail = data.detail;

  if (typeof detail === 'string' && detail.trim()) {
    return detail;
  }

  if (Array.isArray(detail)) {
    const messages = detail
      .map(formatValidationDetail)
      .filter((message): message is string => Boolean(message));
    if (messages.length > 0) {
      return messages.join('; ');
    }
    if (detail.length > 0) {
      return JSON.stringify(detail);
    }
  }

  if (detail && typeof detail === 'object') {
    const detailObject = detail as { msg?: unknown; message?: unknown; original_error?: unknown; error?: unknown };
    if (typeof detailObject.msg === 'string' && detailObject.msg.trim()) {
      return detailObject.msg;
    }
    if (typeof detailObject.message === 'string' && detailObject.message.trim()) {
      return detailObject.message;
    }
    if (typeof detailObject.original_error === 'string' && detailObject.original_error.trim()) {
      return detailObject.original_error;
    }
    if (typeof detailObject.error === 'string' && detailObject.error.trim()) {
      return detailObject.error;
    }
    return JSON.stringify(detail);
  }

  if (typeof data.error === 'string' && data.error.trim()) {
    return data.error;
  }

  if (typeof data.message === 'string' && data.message.trim()) {
    return data.message;
  }

  return fallback;
}
